import React from "react";
import {AdmissionFromSearch} from "../../../../../services/AdmissionsService";
import {AdmissionCardActionsMenu} from "../AdmissionCardActionsMenu";
import {DeleteAdmissionDropdownItem} from "../DeleteAdmissionDropdownItem";
import {ViewAdmissionDropdownItem} from "../ViewAdmissionDropdownItem";
import {ReturnToResidentDropdownItem} from "./ReturnToResidentDropdownItem";
import {ForceDeleteAdmissionDropdownItem} from "../ForceDeleteAdmissionDropdownItem";
import {getResidentTestId} from "../../../helper";

type Props = Readonly<{
  admission: AdmissionFromSearch;
}>;

export const SignedSplitButton = ({admission}: Props) => (
  <AdmissionCardActionsMenu
    testId={getResidentTestId(admission, "signedCardActions")}
  >
    <ViewAdmissionDropdownItem admission={admission} />
    <ReturnToResidentDropdownItem admission={admission} />
    <DeleteAdmissionDropdownItem admission={admission} />
    <ForceDeleteAdmissionDropdownItem admission={admission} />
  </AdmissionCardActionsMenu>
);
